export const logRequest = (method, endpoint, requestBody) => {
  console.log(`${method}: ${endpoint} ResquestBody \n`, requestBody, '\n')
}

export const logResponse = (method, endpoint, response) => {
  console.log(`${method}: ${endpoint} Success \n`, response, '\n')
}

export const logError = (method, endpoint, err) => {
  console.error(`${method}: ${endpoint} Failed \n`, err, '\n')
}
